export const STAFF_NAV = [
  {
    id: "overview",
    label: "Trọng tài",
    items: [
      {
        label: "Trận của tôi",
        path: "/staff/matches",
        icon: "trophy",
      },
    ],
  },
];
